// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1L6-R","right":"styles_right__2Q_hb"};